import { render, staticRenderFns } from "./PrioritiesModal.vue?vue&type=template&id=ad9cb716&"
import script from "./PrioritiesModal.vue?vue&type=script&lang=js&"
export * from "./PrioritiesModal.vue?vue&type=script&lang=js&"
import style0 from "./PrioritiesModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports